import Vue from 'vue';
import { eventHub } from '../../utils/eventhub';

const self = new Vue();

const state = {
  client: {},
  vibbrantes: [],
  selected_vibbrantes:
    JSON.parse(localStorage.getItem('selected-vibbrantes')) || [],
  client_pending_contracts: [],
  client_actives_contracts: [],
  client_closed_contracts: [],
  client_current_contract: {},
  client_balances: {},
  client_notifications: [],
};

const actions = {
  loadClientProfileData(context, response) {
    context.commit('LOAD_CLIENT_PROFILE', response);
  },
  loadClientWaitingAnswerContracts(context, response) {
    context.commit('LOAD_CLIENT_PENDING_CONTRACTS', response);
  },
  loadClientActivesContracts(context, response) {
    context.commit('LOAD_CLIENT_ACTIVES_CONTRACTS', response);
  },
  loadClientClosedContracts(context, response) {
    context.commit('LOAD_CLIENT_CLOSED_CONTRACTS', response);
  },
  search(context, response) {
    context.commit('SEARCH_VIBBRANTES', response);
  },
  addSelVibbrante(context, vibbrante) {
    context.commit('ADD_SEL_VIBBRANTE', vibbrante);
    context.commit('SEARCH_VIBBRANTES', state.vibbrantes);
  },
  addSelVibbranteDirect(context, vibbrante) {
    context.commit('ADD_SEL_VIBBRANTE', vibbrante);
  },
  delSelVibbrante(context, vibbrante) {
    context.commit('REMOVE_SEL_VIBBRANTE', vibbrante);
  },
  delAllSelVibbrante(context) {
    context.commit('REMOVE_ALL_SEL_VIBBRANTE');
  },
  reloadSelectedVibbrantes(context) {
    context.commit('RELOAD_SEL_VIBBRANTE');
  },
  clearVibbrantes(context) {
    context.commit('CLEAR_SEL_VIBBRANTES');
  },
  loadClientCurrentContract(context, response) {
    context.commit('LOAD_CLIENT_CURRENT_CONTRACT', response);
  },
  loadClientBalance(context, response) {
    context.commit('CLIENT_BALANCES', response);
  },
  loadClientNotifications(context, response) {
    context.commit('LOAD_CLIENT_NOTIFICATION', response);
  },
};

const mutations = {
  LOAD_CLIENT_PROFILE: (state, response) => {
    state.client = response;
  },
  SEARCH_VIBBRANTES: (state, response) => {
    eventHub.$emit('before-request');
    let findVibbrante = false;

    state.vibbrantes = [];

    for (let i = 0; i < response.length; i += 1) {
      findVibbrante = false;
      for (let j = 0; j < state.selected_vibbrantes.length; j += 1) {
        if (state.selected_vibbrantes[j].id === response[i].id) {
          findVibbrante = true;
        }
      }
      if (!findVibbrante) {
        state.vibbrantes.push(response[i]);
      }
    }

    eventHub.$emit('after-response');
  },
  ADD_SEL_VIBBRANTE: (state, vibbrante) => {
    state.selected_vibbrantes =
      JSON.parse(localStorage.getItem('selected-vibbrantes')) || [];
    let findVibbrante = false;
    for (let i = 0; i < state.selected_vibbrantes.length; i += 1) {
      if (state.selected_vibbrantes[i].id === vibbrante.id) {
        findVibbrante = true;
      }
    }
    if (!findVibbrante) {
      state.selected_vibbrantes.push(vibbrante);
    }
    localStorage.setItem(
      'selected-vibbrantes',
      JSON.stringify(state.selected_vibbrantes)
    );
  },
  REMOVE_SEL_VIBBRANTE: (state, vibbrante) => {
    const index = state.selected_vibbrantes.indexOf(vibbrante);
    if (index > -1) {
      state.selected_vibbrantes.splice(index, 1);
    }
    localStorage.setItem(
      'selected-vibbrantes',
      JSON.stringify(state.selected_vibbrantes)
    );
  },
  REMOVE_ALL_SEL_VIBBRANTE: state => {
    state.selected_vibbrantes = [];
    localStorage.setItem(
      'selected-vibbrantes',
      JSON.stringify(state.selected_vibbrantes)
    );
  },
  RELOAD_SEL_VIBBRANTE: state => {
    state.selected_vibbrantes =
      JSON.parse(localStorage.getItem('selected-vibbrantes')) || [];
  },
  CLEAR_SEL_VIBBRANTES: state => {
    state.selected_vibbrantes = [];
    localStorage.setItem(
      'selected-vibbrantes',
      JSON.stringify(state.selected_vibbrantes)
    );
  },
  LOAD_CLIENT_PENDING_CONTRACTS: (state, response) => {
    state.client_pending_contracts = response;
  },
  LOAD_CLIENT_ACTIVES_CONTRACTS: (state, response) => {
    state.client_actives_contracts = response;
  },
  LOAD_CLIENT_CLOSED_CONTRACTS: (state, response) => {
    state.client_closed_contracts = response;
  },
  LOAD_CLIENT_CURRENT_CONTRACT: (state, response) => {
    state.client_current_contract = response;
    // state.client_current_contract.expected_start_date = self.$moment(response.expected_start_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
  },
  CLIENT_BALANCES: (state, response) => {
    state.client_balances = response;
  },
  LOAD_CLIENT_NOTIFICATION: (state, response) => {
    state.client_notifications = response;
  },
};

const getters = {
  clientProfile: state => state.client,
  vibbrantes: state => state.vibbrantes,
  selected_vibbrantes: state => state.selected_vibbrantes,
  client_pending_contracts: state => state.client_pending_contracts,
  client_actives_contracts: state => state.client_actives_contracts,
  client_closed_contracts: state => state.client_closed_contracts,
  client_current_contract: state => state.client_current_contract,
  client_balances: state => state.client_balances,
  client_notifications: state => state.client_notifications,
};

export default {
  state,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/client.js